module.exports = __webpack_public_path__ + "static/media/archive.30d13f43.svg";